module.exports = __webpack_public_path__ + "static/media/02 Generali OZE Karta produktu.e3da380b.pdf";